import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = ["srcset", "sizes"]
const _hoisted_3 = ["srcset", "sizes"]
const _hoisted_4 = ["src", "srcset", "sizes", "alt"]

import { computed, ref } from "vue";
import { getClasses } from "~/js/composables/classes";
import { Image } from "~/js/interfaces/media";

interface Props {
	image: Image;
	ratio?: string;
	sizes?: Array<string>;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageLogo',
  props: {
    image: {},
    ratio: { default: "w-full h-auto" },
    sizes: {},
    utilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const sizes = computed(() => {
	if (props.sizes) {
		return props.sizes.join(",");
	}

	return "100vw";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    "aria-labelledby": __props.image.alt,
    class: _normalizeClass([__props.utilities, __props.ratio])
  }, [
    _createElementVNode("picture", {
      class: _normalizeClass(__props.ratio)
    }, [
      _createElementVNode("source", {
        srcset: __props.image.srcsetWebP,
        sizes: sizes.value,
        type: "image/webp"
      }, null, 8, _hoisted_2),
      _createElementVNode("source", {
        srcset: __props.image.srcset,
        sizes: sizes.value
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        src: __props.image.placeholder,
        srcset: __props.image.srcset,
        sizes: sizes.value,
        alt: __props.image.alt,
        loading: "lazy"
      }, null, 8, _hoisted_4)
    ], 2)
  ], 10, _hoisted_1))
}
}

})